<template>
  <div>
    <b-row>
      <b-col>
        <ulu-finance-revenue />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <ulu-finance-kpi />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-finance-revenue": () =>
      import(
        "@/components/dashboard/finance/finance_revenue/FinanceRevenue.vue"
      ),
    "ulu-finance-kpi": () =>
      import(
        "@/components/dashboard/finance/finance_kpi/FinanceKpi.vue"
      )
  },
};
</script>
